'use strict';
import angular from 'angular';
import customMacros2HtmlUrl from './views/customMacros2.html';

let app = angular.module('app.customMacros2Component', []);

const StandardMacros = [
    'CONNECT_FIRSTNAME',
    'CONNECT_LASTNAME',
    'CONNECT_ADDRESS',
    'CONNECT_ADDRESS2',
    'CONNECT_CITY',
    'CONNECT_STATE',
    'CONNECT_ZIP',
];

// These macros do not need to be displayed as options in the widget, but are valid (and should not come back as RED if found in HTML).
const HiddenMacros = [
    'CONNECT_EMAIL',
    'CONNECT_ID',
    'CONNECT_ORDERID',
    'CONNECT_FLIGHTID',
    'CONNECT_MD5EMAIL',
    'CONNECT_MD5EMAIL_UPPER',
    'CONNECT_MD5EMAIL_LOWER',
    'CONNECT_SHA1EMAIL',
    'CONNECT_SHA256EMAIL',
];

app.component('customMacros2', {
    bindings: {
        audienceMacroMappings: '<',
        emailMacros: '<',
        htmlValidationStatus: '<',
    },
    templateUrl: customMacros2HtmlUrl,
    controller: function () {
        let self = this;
        self.macroList = [];
        self.extraList = [];
        self.dataFound = false;
        self.extras = false;
        if (!self.audienceMacroMappings) {
            self.audienceMacroMappings = [];
        } else {
            self.audienceMacroMappings = Object.values(self.audienceMacroMappings);
        }
        if (!self.emailMacros) {
            self.emailMacros = [];
        } else {
            // This field is sent to us from the backend as a string.
            self.emailMacros = JSON.parse(self.emailMacros);
        }

        if (self?.htmlValidationStatus?.toLowerCase() === 'success') {
            // HTML Validation has successfully run.
            self.dataFound = true;
            const foundStandard = [];
            const foundYours = [];
            // Sort the macros found in HTML (in the __email_macros form field) according to whether they are:
            // 1) A standard Bridge macro
            // 2) A user macro which is a header of the Match and Activate CSV file
            // 3) Not found in the Match and Activate CSV file, and not a standard Bridge macro either, aka extra macros.
            //    These extra macros show up in red on the widget.
            self.emailMacros.forEach((macro) => {
                const upperCaseMacro = macro.toUpperCase();
                if (StandardMacros.includes(upperCaseMacro) || HiddenMacros.includes(upperCaseMacro)) {
                    foundStandard.push(macro);
                } else if (self.audienceMacroMappings.some(mapping => mapping.toUpperCase() == upperCaseMacro)) {
                    foundYours.push(macro);
                } else {
                    self.extraList.push(macro);
                    self.extras = true;
                }
            });
            // Now format the data for use by the HTML page
            let index = 0;
            foundStandard.forEach((standardMacro) => {
                const m = {};
                m.standardMacro = standardMacro;
                m.yourMacro = ''; // May get overwritten below
                self.macroList[index++] = m;
            });
            // Rewind the index and loop over "Your Macros" now.
            index = 0;
            foundYours.forEach((yourMacro) => {
                let m = self.macroList[index];
                if (m) {
                    m = self.macroList[index++];
                } else {
                    m = {};
                    m.standardMacro = '';
                    self.macroList[index++] = m;
                }
                m.yourMacro = yourMacro;
            });
            // Handle the case where there are no standard and no "yours" macros.
            if (foundStandard.length === 0 && foundYours.length === 0) {
                const m = {};
                m.standardMacro = '(not found)';
                m.yourMacro = '(not found)';
                self.macroList[0] = m;
            }
        } else {
            // Prior to HTML Validation being completed.
            // Always show all the standard Bridge macros on the leftmost column, and the user macros on the rightmost
            // column. The user macros are all the headers of the Match and Activate CSV file.
            let index = 0;
            StandardMacros.forEach((standardMacro) => {
                const m = {};
                m.standardMacro = standardMacro;
                m.yourMacro = ''; // May get overwritten below
                self.macroList[index++] = m;
            });
            // Rewind the index and loop over "Your Macros" now.
            index = 0;
            self.audienceMacroMappings.forEach((yourMacro) => {
                const upperCaseMacro = yourMacro.toUpperCase();
                if (!HiddenMacros.includes(upperCaseMacro)) {
                    let m;
                    // Handle the cases where there might be more standard macros, or more user macros.
                    if (index < StandardMacros.length) {
                        m = self.macroList[index++];
                    } else {
                        // There are more user macros, so create additional rows.
                        m = {};
                        m.standardMacro = ''; // Will remain blank, there are more user macros than standard macros
                        self.macroList[index++] = m;
                    }
                    m.yourMacro = yourMacro;
                }
            });
        }
    }
});
